import React from "react";

function SvgPsd(props) {
  let blur = "";
  if (props.activeMove) {
    blur = 40;
  }
  return (
    <svg
    style={{verticalAlign:"middle"}}
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 212.187 205.286"
    >
      <g id="archive" transform="translate(-26.483)">
        <g id="Group_6670" data-name="Group 6670" transform="translate(67.288)">
          <path
            id="Path_16555"
            data-name="Path 16555"
            d="M239.1,333.781c-1.381,4.979-1.381,12,4.282,20.063,5.354,7.622,13.336,12.323,20.581,15.2C252.3,358.341,243.61,344.071,239.1,333.781Z"
            transform="translate(-181.211 -199.952)"
            fill={"#6eaadc"+blur}
          />
          <path
            id="Path_16556"
            data-name="Path 16556"
            d="M280.613,359.227a105.107,105.107,0,0,1-1.707-10.712c-.269-2.185-.528-4.289-.871-6.236h-4.76a3.838,3.838,0,0,1-4.081-3.54v-6.059c-3.333-4.307-9.293-7.468-14.313-9.462C259.046,333.312,268.523,348.739,280.613,359.227Z"
            transform="translate(-190.11 -193.625)"
            fill={"#6eaadc"+blur}
          />
          <path
            id="Path_16557"
            data-name="Path 16557"
            d="M249.416,42.473c-6.761,0-12.242-4.754-12.242-10.618V0H127c-6.761,0-12.242,4.754-12.242,10.618V35.394H216.771c4.507,0,8.161,3.17,8.161,7.079V92.025c0,3.909-3.654,7.079-8.161,7.079H114.758v95.564c0,5.864,5.481,10.618,12.242,10.618H273.9c6.761,0,12.242-4.754,12.242-10.618V42.473ZM230.567,184.049h-.046A40.991,40.991,0,0,1,214.5,180.5c-.085,0-.17.014-.256.014-.134,0-.267-.007-.4-.017-1.207-.1-29.731-2.765-43.889-22.916-14-19.93-.3-35.259.293-35.9.008-.008.017-.014.024-.023a3.9,3.9,0,0,1,.377-.354l.02-.016a4.069,4.069,0,0,1,.419-.293l.043-.026a4.312,4.312,0,0,1,.986-.429l.073-.021a4.621,4.621,0,0,1,.544-.121,4.794,4.794,0,0,1,.5-.044c.059,0,.117,0,.176,0,.12,0,.238,0,.356.012.059,0,.117.006.175.012a4.754,4.754,0,0,1,.476.077c.021,0,.042.005.062.01.785.176,19.315,4.5,26.964,15.786a3.182,3.182,0,0,1,.563,1.794v3.54h4.081a4,4,0,0,1,3.985,2.779,80.323,80.323,0,0,1,1.6,9.782c.809,6.556,1.652,13.314,4.986,19.232a32.126,32.126,0,0,0,13.958,3.6,3.573,3.573,0,1,1-.046,7.08Z"
            transform="translate(-114.758)"
            fill={"#6eaadc"+blur}
          />
        </g>
        <g id="Group_6671" data-name="Group 6671" transform="translate(26.483)">
          <path
            id="Path_16558"
            data-name="Path 16558"
            d="M391.828,42.473h36.725L379.586,0V31.855C379.586,37.719,385.067,42.473,391.828,42.473Z"
            transform="translate(-216.365)"
            fill="#4b8cc8"
          />
          <path
            id="Path_16559"
            data-name="Path 16559"
            d="M177.462,144.907V95.355c0-3.909-3.654-7.079-8.161-7.079H34.644c-4.507,0-8.161,3.17-8.161,7.079v49.552c0,3.909,3.654,7.079,8.161,7.079H169.3C173.809,151.985,177.462,148.816,177.462,144.907Zm-112.214-17.7H50.966v7.079a3.838,3.838,0,0,1-4.081,3.54,3.838,3.838,0,0,1-4.081-3.54V105.973a3.838,3.838,0,0,1,4.081-3.54H65.248c7.874,0,14.282,5.558,14.282,12.388S73.122,127.209,65.248,127.209Zm42.845,10.618h-20.4a3.575,3.575,0,1,1,0-7.079h20.4a3.575,3.575,0,1,0,0-7.079H95.852c-6.75,0-12.242-4.763-12.242-10.618s5.491-10.618,12.242-10.618h16.322a3.575,3.575,0,1,1,0,7.079H95.852a3.575,3.575,0,1,0,0,7.079h12.242c6.75,0,12.242,4.763,12.242,10.618S114.844,137.828,108.093,137.828Zm32.644,0H128.5a3.838,3.838,0,0,1-4.081-3.54V105.973a3.838,3.838,0,0,1,4.081-3.54h12.242c11.25,0,20.4,7.939,20.4,17.7S151.987,137.828,140.738,137.828Z"
            transform="translate(-26.483 -52.882)"
            fill="#4b8cc8"
          />
          <path
            id="Path_16560"
            data-name="Path 16560"
            d="M264.161,141.241H256v21.237h8.161c6.75,0,12.242-4.763,12.242-10.618S270.911,141.241,264.161,141.241Z"
            transform="translate(-149.906 -84.61)"
            fill="#4b8cc8"
          />
          <path
            id="Path_16561"
            data-name="Path 16561"
            d="M93.73,141.241H79.448v10.618H93.73c3.375,0,6.121-2.382,6.121-5.309S97.1,141.241,93.73,141.241Z"
            transform="translate(-54.965 -84.61)"
            fill="#4b8cc8"
          />
        </g>
        <g
          id="Group_6672"
          data-name="Group 6672"
          transform="translate(42.805 49.551)"
        >
          <path
            id="Path_16562"
            data-name="Path 16562"
            d="M84.236,123.586H65.874a3.838,3.838,0,0,0-4.081,3.54v28.315a4.122,4.122,0,0,0,8.161,0v-7.079H84.236c7.874,0,14.282-5.558,14.282-12.388S92.11,123.586,84.236,123.586Zm0,17.7H69.954V130.665H84.236c3.375,0,6.121,2.382,6.121,5.309S87.611,141.283,84.236,141.283Z"
            transform="translate(-61.793 -123.586)"
            fill="#fff"
          />
          <path
            id="Path_16563"
            data-name="Path 16563"
            d="M174.551,137.743H162.31a3.575,3.575,0,1,1,0-7.079h16.322a3.575,3.575,0,1,0,0-7.079H162.31c-6.75,0-12.242,4.763-12.242,10.618s5.492,10.618,12.242,10.618h12.242a3.575,3.575,0,1,1,0,7.079h-20.4a3.575,3.575,0,1,0,0,7.079h20.4c6.75,0,12.242-4.763,12.242-10.618S181.3,137.743,174.551,137.743Z"
            transform="translate(-109.263 -123.585)"
            fill="#fff"
          />
          <path
            id="Path_16564"
            data-name="Path 16564"
            d="M254.666,123.586H242.425a3.838,3.838,0,0,0-4.081,3.54v28.315a3.838,3.838,0,0,0,4.081,3.54h12.242c11.25,0,20.4-7.939,20.4-17.7S265.916,123.586,254.666,123.586Zm0,28.315h-8.161V130.665h8.161c6.75,0,12.242,4.763,12.242,10.618S261.417,151.9,254.666,151.9Z"
            transform="translate(-156.734 -123.586)"
            fill="#fff"
          />
          <path
            id="Path_16565"
            data-name="Path 16565"
            d="M287.523,356.777a32.126,32.126,0,0,1-13.958-3.6c-3.335-5.918-4.177-12.676-4.986-19.232a80.226,80.226,0,0,0-1.6-9.782,4,4,0,0,0-3.985-2.779h-4.081v-3.54a3.188,3.188,0,0,0-.563-1.794c-7.649-11.282-26.178-15.609-26.964-15.786-.021,0-.042-.006-.062-.01a4.543,4.543,0,0,0-.476-.077c-.059-.006-.116-.008-.175-.012q-.177-.013-.356-.012c-.059,0-.117,0-.176,0a4.68,4.68,0,0,0-.5.044,4.629,4.629,0,0,0-.544.121l-.073.021a4.3,4.3,0,0,0-.986.429L228,300.8a3.952,3.952,0,0,0-.419.293l-.02.016a3.847,3.847,0,0,0-.377.354c-.008.008-.017.014-.024.023-.59.643-14.294,15.973-.293,35.9,14.159,20.151,42.683,22.813,43.889,22.916.134.01.267.017.4.017.086,0,.171-.009.256-.014a40.993,40.993,0,0,0,16.02,3.554h.046a3.573,3.573,0,1,0,.046-7.08Zm-36.771-37.914v6.059a3.838,3.838,0,0,0,4.081,3.54h4.76c.343,1.946.6,4.051.871,6.236a105.5,105.5,0,0,0,1.707,10.712c-12.09-10.488-21.567-25.916-25.731-36.008C241.46,311.395,247.419,314.556,250.752,318.863ZM233.835,333.7c-5.663-8.059-5.663-15.084-4.282-20.063,4.515,10.29,13.209,24.561,24.862,35.263C247.17,346.021,239.189,341.32,233.835,333.7Z"
            transform="translate(-147.185 -229.358)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}
export default React.memo(SvgPsd);
